export default "__VITE_ASSET__BdxgN6PX__"